import { Controller } from "@hotwired/stimulus"

// "School year" dropdown on Class Picture Corrections (schools#class_pictures).
// Navigates to the selected past/current season, preserving the
// currently-selected teacher if one is present.
export default class extends Controller {
  static targets = ["select"]
  static values = {
    schoolId: Number,
    teacherId: String
  }

  navigate() {
    let url = `/schools/${this.schoolIdValue}/class_pictures?season=${encodeURIComponent(this.selectTarget.value)}`
    if (this.teacherIdValue) {
      url += `&teacher_id=${encodeURIComponent(this.teacherIdValue)}`
    }
    window.location = url
  }
}
